import Combobox from '@standardsdigital/ui-components/Combobox';
import type {
  ComboboxAnnouncementTexts,
  ComboboxOption,
} from '@standardsdigital/ui-components/Combobox';
import { useTranslation } from 'react-i18next';
import FieldStatusWrapper from 'components/global/FieldStatusWrapper/FieldStatusWrapper';
import {
  addSelectedValue,
  messageSeverity,
  removeSelectedValues,
} from './formInputHelpers';

interface AllowedNsbsSelectProps {
  options: ComboboxOption[];
  selectedOptions: ComboboxOption[];
  value: string[];
  onChange: (value: string[]) => void;
  allowMultiple: boolean;
  announcementTexts: ComboboxAnnouncementTexts;
  error?: string;
  isDirty: boolean;
  disabled: boolean;
}

function AllowedNsbsSelect({
  options,
  selectedOptions,
  value,
  onChange,
  allowMultiple,
  announcementTexts,
  error,
  isDirty,
  disabled,
}: Readonly<AllowedNsbsSelectProps>) {
  const { t } = useTranslation();

  const handleSelect = (option: ComboboxOption) => {
    onChange(allowMultiple ? addSelectedValue(value, option.value) : [option.value]);
  };

  const handleRemove = (optionsToRemove: ComboboxOption[]) => {
    onChange(allowMultiple ? removeSelectedValues(value, optionsToRemove) : []);
  };

  const comboboxKey = allowMultiple ? 'allowedNsbs-tags' : 'allowedNsbs-single';
  const comboboxLabel = t(
    allowMultiple
      ? 'serviceLevels.form.allowedNsbs'
      : 'serviceLevels.form.allowedNsb',
  );
  const comboboxSelection = allowMultiple ? 'tags' : 'single';

  return (
    <FieldStatusWrapper isDirty={isDirty}>
      <Combobox
        key={comboboxKey}
        label={comboboxLabel}
        selection={comboboxSelection}
        selectionModeLabel={t('serviceLevels.form.allowedNsbs')}
        options={options}
        selectedOptions={selectedOptions}
        announcementTexts={announcementTexts}
        clearButtonText={t('general.clearSearch')}
        onSelect={handleSelect}
        onRemove={handleRemove}
        disabled={disabled}
        required
        inputProps={{ message: error, severity: messageSeverity(error) }}
      />
    </FieldStatusWrapper>
  );
}

export default AllowedNsbsSelect;
